/** Normalize store/supplier list entries from different API shapes. */
export const getEntityId = (entity) =>
  String(entity?._id ?? entity?.id ?? entity?.value ?? '');

export const getEntityName = (entity) =>
  String(entity?.name ?? entity?.label ?? entity?.value ?? 'Unknown');
